import React from 'react'
import { Navigation } from './Navigation'
import { StatusFooter } from './StatusFooter'

interface LayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-dark-900 flex flex-col">
      <Navigation />
      <main className="flex-grow">
        {children}
      </main>
      <StatusFooter />
    </div>
  )
}
